import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";
import { readDeveloperMode } from "../../shared/developerMode";

const initialState = {
  authToken: null,
  id: null,
  name: "",
  email: "",
  user_type: 0,
  tenant: null,
  roles: [],
  permissions: [],
  finance: null,
  developerMode: readDeveloperMode(),
  error: null,
};

const authStart = (state) => {
  return updateObject(state, { error: null, loading: true });
};

const authSuccess = (state, action) => {
  return updateObject(state, {
    authToken: action.authToken,
    error: null,
    name: action.name,
    email: action.email,
    id: action.id,
    user_type: action.user_type,
    tenant: action.tenant ?? null,
    roles: action.roles ?? [],
    permissions: action.permissions ?? [],
    ...(action.hasFinance ? { finance: action.finance ?? null } : {}),
  });
};

const updateFinanceCapability = (state, action) => {
  return updateObject(state, {
    finance: action.finance ?? null,
  });
};

const authFail = (state, action) => {
  if (action.error.data) {
    return updateObject(state, {
      error: {
        title: action.error.data.title,
        subtitle: action.error.data.subtitle,
      },
      loading: false,
    });
  }
  return updateObject(state, {
    error: {
      title: "",
      subtitle: "We could not complete your request, please try again.",
    },
    loading: false,
  });
};

const authLogout = (state) => {
  return updateObject(state, {
    authToken: null,
    fname: null,
    user_id: null,
    tenant: null,
    roles: [],
    permissions: [],
    finance: null,
  });
};

const updateAccount = (state, action) => {
  return updateObject(state, {
    name: action.name,
    email: action.email,
  });
};

const updateTenant = (state, action) => {
  return updateObject(state, {
    tenant: action.tenant,
  });
};

const setDeveloperMode = (state, action) => {
  return updateObject(state, {
    developerMode: action.developerMode,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_START:
      return authStart(state);
    case actionTypes.AUTH_SUCCESS:
      return authSuccess(state, action);
    case actionTypes.AUTH_FAIL:
      return authFail(state, action);
    case actionTypes.AUTH_LOGOUT:
      return authLogout(state);
    case actionTypes.UPDATE_ACCOUNT_SUCCESS:
      return updateAccount(state, action);
    case actionTypes.UPDATE_TENANT_SUCCESS:
      return updateTenant(state, action);
    case actionTypes.UPDATE_FINANCE_CAPABILITY:
      return updateFinanceCapability(state, action);
    case actionTypes.SET_DEVELOPER_MODE:
      return setDeveloperMode(state, action);

    default:
      return state;
  }
};

export default reducer;
